<template>
  <div>
    <v-sheet elevation="1">
      <v-toolbar dense color="white">
        <v-toolbar-title>{{ screenTitle }}</v-toolbar-title>
      </v-toolbar>
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <v-form ref="form" v-model="isPassedValidSearchForm">
          <p style="margin: 0 0 10px 0">
            以下の条件を設定した場合、条件に一致する避難者が一覧に表示されます。
          </p>
          <div style="margin: 0 0 10px 20px">
            <p>
              以下の住民情報を検索検索することが可能です。<br />
              避難者（住民）検索を選択した場合は、以下の４つの情報を検索することができます。<br />
              「スマートフォンアプリ」「仮ＱＲコード」「学校ＱＲコード」「要配慮者施設ＱＲコード」<br />
              避難行動要支援者検索を選択した場合は、避難行動要支援者名簿より登録された住民の情報を検索することができます。<br />
              （スマートフォンや仮ＱＲコードから住民情報が登録されていた場合は、その情報を合わせて表示します。）
            </p>
            <v-radio-group
              v-model="searchItem.search_type"
              :rules="[searchTypeCheck]"
              row
              style="width: 410px"
            >
              <v-radio
                label="避難者（住民）検索"
                value="evacuee"
                @click="radioClick()"
              ></v-radio>
              <v-radio
                label="避難行動要支援者検索"
                value="support"
                @click="radioClick()"
              ></v-radio>
            </v-radio-group>
          </div>

          <v-row>
            <v-col cols="6" md="3">
              <v-select
                v-model="searchItem.scope"
                :items="scopeStatus"
                :rules="[scopeCheck]"
                label="情報区分"
                placeholder="選択してください"
                multiple
                clearable
                outlined
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" md="3">
              <v-select
                v-model="searchItem.disaster_no"
                :items="disaster"
                item-text="disaster_name"
                item-value="disaster_no"
                :rules="[$validation.rules.required]"
                label="災害名称"
                placeholder="選択してください"
                clearable
                outlined
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row v-if="false">
            <v-col cols="4">
              <v-text-field
                label="ID"
                placeholder="入力してください"
                clearable
                outlined
                counter="36"
                maxlength="36"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-text-field
                v-model="searchItem.name"
                label="氏名"
                placeholder="入力してください"
                clearable
                outlined
                counter="64"
                maxlength="64"
              >
              </v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="searchItem.name_kana"
                label="氏名カナ"
                placeholder="入力してください"
                outlined
                counter="64"
                maxlength="64"
                :rules="[kanaCheck]"
                :append-icon="nameKanaDelete ? 'mdi-close' : ''"
                @click:append="clearText('name_kana')"
                @keyup="showCancelIcon('name_kana')"
                :disabled="radioCheck()"
              >
              </v-text-field>
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="searchItem.gender"
                label="性別"
                placeholder="選択してください"
                :items="selectEither[1]"
                item-value="status_id"
                item-text="status_text"
                clearable
                outlined
                :disabled="radioCheck()"
              >
              </v-select>
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="searchItem.birthday"
                label="生年月日"
                placeholder="例) 1999/02/12"
                outlined
                counter="10"
                maxlength="10"
                :rules="[birthdayCheck]"
                validate-on-blur
                :append-icon="birthdayDelete ? 'mdi-close' : ''"
                @click:append="clearText('birthday')"
                @keyup="showCancelIcon('birthday')"
                :disabled="radioCheck()"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <v-text-field
                v-model="searchItem.address"
                label="住所"
                placeholder="入力してください"
                clearable
                outlined
                counter="128"
                maxlength="128"
                :disabled="radioCheck()"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-text-field
                v-model="searchItem.fa_name"
                label="施設名"
                placeholder="入力してください"
                clearable
                outlined
                :disabled="radioCheck()"
              >
              </v-text-field>
            </v-col>
            <v-col cols="3">
              <v-select
                v-model="searchItem.last_status"
                :items="statusList"
                item-value="fa_id"
                item-text="fa_type"
                label="最終ステータス"
                placeholder="選択してください"
                clearable
                outlined
                :disabled="radioCheck()"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row v-if="temp">
            <v-col cols="2">
              <v-select
                v-model="searchItem.iodine_predistribution"
                label="安定ヨウ素剤事前配布受取"
                placeholder="選択してください"
                :items="selectEither[0]"
                item-value="status_id"
                item-text="status_text"
                clearable
                outlined
                :disabled="radioCheck()"
              >
              </v-select>
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="searchItem.iodine_possession"
                label="安定ヨウ素剤所持有無"
                placeholder="選択してください"
                :items="selectEither[0]"
                item-value="status_id"
                item-text="status_text"
                clearable
                outlined
                :disabled="radioCheck()"
              >
              </v-select>
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="searchItem.iodine_intake"
                label="安定ヨウ素剤服用"
                placeholder="選択してください"
                :items="selectEither[0]"
                item-value="status_id"
                item-text="status_text"
                clearable
                outlined
                :disabled="radioCheck()"
              >
              </v-select>
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="searchItem.pregnancy_possibility"
                label="妊娠の可能性"
                placeholder="選択してください"
                :items="selectEither[0]"
                item-value="status_id"
                item-text="status_text"
                clearable
                outlined
                :disabled="radioCheck()"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row v-if="temp">
            <v-col cols="8">
              <v-text-field
                v-model="searchItem.required_consideration"
                label="要配慮の理由"
                placeholder="入力してください"
                clearable
                outlined
                maxlength="30"
                counter="30"
                :disabled="radioCheck()"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                class="mx-2"
                color="primary"
                style="width: 130px"
                :disabled="!isPassedValidSearchForm"
                @click="showSearchDialog()"
              >
                検索
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <v-dialog v-model="searchDialog" persistent max-width="400">
        <v-card>
          <v-card-title></v-card-title>
          <v-card-text>
            <p>
              検索に時間を要する場合があります。<br />実行してよろしいですか？
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="mx-2" color="primary" @click="search()">
              OK
            </v-btn>
            <v-btn class="mx-2" color="primary" @click="searchDialog = false">
              キャンセル
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-overlay :value="dialogOverlay" opacity="1" color="white">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-dialog>

      <v-divider class="mb-3" />
      <v-data-table
        :headers="summaryHeader"
        :items="summaryFiled"
        hide-default-footer
      >
        <template v-slot:[`item.shelter_count`]="{ item }">
          {{ item.shelter_count | format }}
        </template>
        <template v-slot:[`item.temp_shelter_count`]="{ item }">
          {{ item.temp_shelter_count | format }}
        </template>
        <template v-slot:[`item.inspection_site_count`]="{ item }">
          {{ item.inspection_site_count | format }}
        </template>
        <template v-slot:[`item.bus_evacuation_count`]="{ item }">
          {{ item.bus_evacuation_count | format }}
        </template>
        <template v-slot:[`item.none_count`]="{ item }">
          {{ item.none_count | format }}
        </template>
        <template v-slot:[`item.total_count`]="{ item }">
          {{ item.total_count | format }}
        </template>
      </v-data-table>
      <v-divider class="mb-5" />
      <div v-if="evacuee_table" style="margin-left: 10px; font-size: 12px;">
        【凡例】
        <div>
          情報区分は、以下より登録された住民情報を示します。
        </div>
        <div style="margin-left: 10px;">
          ス：スマートフォンアプリ
          <span style="margin-left: 7px;">仮：仮ＱＲコード</span>
          <span style="margin-left: 7px;">学校：学校ＱＲコード</span>
          <span style="margin-left: 7px;">配慮：要配慮者施設ＱＲコード</span>
          <span style="margin-left: 7px;">支援：避難行動要支援者名簿</span>
        </div>
      </div>
      <top-operation-data-table
        :headers="evacueeListHeader"
        :items="evacueeList"
        :loading="loading"
        locale="ja-jp"
        dispMode="nowrap"
        class="fixedWidth"
        loading-text="読込中"
        ref="summary"
        v-if="evacuee_table"
      >
        <template v-slot:[`item.name`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="text-truncate d-inline-block"
                style="max-width: 720px"
              >
                {{ item.name }}
              </span>
            </template>
            <span> {{ item.name }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.name_kana`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="text-truncate d-inline-block"
                style="max-width: 720px"
              >
                {{ item.name_kana }}
              </span>
            </template>
            <span> {{ item.name_kana }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.address`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="text-truncate d-inline-block"
                style="max-width: 720px"
              >
                {{ item.address }}
              </span>
            </template>
            <span> {{ item.address }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.showDetails`]="data">
          <v-btn
            class="mx-2"
            color="primary"
            small
            @click="showDialog(data.item)"
          >
            表示
          </v-btn>
        </template>
      </top-operation-data-table>
    </v-sheet>
    <v-dialog v-model="detailsDialog">
      <form>
        <v-card>
          <v-card-title>
            <span class="headline">避難者詳細情報</span>
          </v-card-title>
          <v-container>
            <v-row v-if="false">
              <v-col cols="3">
                <v-text-field
                  label="ID"
                  placeholder=" "
                  :value="evacueeDetails.user_id"
                  disabled
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-textarea
                  label="氏名"
                  placeholder=" "
                  :value="this.evacueeDetails.name"
                  readonly
                  rows="1"
                >
                </v-textarea>
              </v-col>
              <v-col cols="3">
                <v-textarea
                  label="氏名カナ"
                  placeholder=" "
                  :value="evacueeDetails.name_kana"
                  readonly
                  rows="1"
                >
                </v-textarea>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  label="性別"
                  placeholder=" "
                  :value="evacueeDetails.gender"
                  readonly
                >
                </v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  label="生年月日"
                  placeholder=" "
                  :value="evacueeDetails.birthday"
                  readonly
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="10">
                <v-textarea
                  label="住所"
                  placeholder=" "
                  :value="evacueeDetails.address"
                  readonly
                >
                </v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="7">
                <v-text-field
                  label="施設名"
                  placeholder=" "
                  :value="evacueeDetails.fa_name"
                  disabled
                >
                </v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  label="最終ステータス"
                  placeholder=" "
                  :value="evacueeDetails.final_status"
                  readonly
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="2">
                <v-text-field
                  label="安定ヨウ素剤事前配布受取"
                  placeholder=" "
                  :value="evacueeDetails.iodine_predistribution"
                  readonly
                >
                </v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  label="安定ヨウ素剤所持"
                  placeholder=" "
                  :value="evacueeDetails.iodine_possession"
                  readonly
                >
                </v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  label="安定ヨウ素剤服用"
                  placeholder=" "
                  :value="evacueeDetails.iodine_intake"
                  readonly
                >
                </v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  label="妊娠の可能性"
                  placeholder=" "
                  :value="evacueeDetails.pregnancy_possibility"
                  readonly
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="10">
                <v-text-field
                  label="要配慮の理由"
                  placeholder=" "
                  :value="evacueeDetails.required_consideration"
                  readonly
                >
                </v-text-field>
              </v-col>
            </v-row>
            <div>避難履歴</div>
            <v-data-table
              :headers="evacueeActionHistorysHeader"
              :items="evacueeDetails.evacuation_history"
              :sort-by="sort.by"
              :sort-desc="sort.desc"
              hide-default-footer
            >
            </v-data-table>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="mx-2" color="primary" @click="detailsDialog = false">
              閉じる
            </v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </v-dialog>
    <v-overlay :value="overlay" opacity="0.5" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import messageUtils from "@/mixins/message-utils";
import { hasProperty } from "@/js/utils";
import { ScreenId } from "@/js/value-objects/screen-id";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { ErrorTodoMessages } from "@/js/constants/error-messages";

const evacueeInfoRepository = RepositoryFactory.get("evacueeInfo");

export default {
  mixins: [messageUtils],
  components: {
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage"),
    TopOperationDataTable: () => import("@/components/ui/TopOperationDataTable")
  },

  data: () => ({
    loading: false,
    overlay: false,
    temp: true,
    evacuee_table: false,
    detailsDialog: false,

    errFlag: false,
    //検索ダイアログ
    searchDialog: false,
    /**
     * 検索条件
     */
    searchItem: {
      search_type: "", // 固定
      scope: "", // 情報区分
      disaster_no: "", // 災害番号
      name: "", // 氏名
      name_kana: "", //氏名カナ
      gender: "", // 性別
      birthday: "", // 生年月日
      address: "", //住所
      fa_name: "", //施設名
      last_status: "", //原子力防災施設区分
      iodine_predistribution: "", //安定ヨウ素剤事前配布受取
      iodine_possession: "", //安定ヨウ素剤所持
      iodine_intake: "", //安定ヨウ素剤服用
      pregnancy_possibility: "", //妊娠の可能性
      required_consideration: "" //要配慮の理由
    },

    // screen data
    screenId: ScreenId.SF1303,
    screenTitle: "",
    // sumary field parameter
    summaryFiled: [],
    // items
    brr: [],
    detailItem: [],
    evacueeList: [],
    pushItem: [],
    pushItems: [],
    //ラジオ選択、情報区分リスト格納
    scopeStatus: [],
    evacueeDetails: [],
    scopeType: "",
    // pull down parameter
    selectEither: cloneDeep(WHICH_CHOOSE),
    statusList: cloneDeep(STATUS_LIST),
    /* 
        引数として入力された文字列が渡され、制約に合致していればtrueを返し、
        合致していなければエラーメッセージの文字列を返す関数
    */
    kanaCheck: value =>
      /^[ァ-ヶ\p{blank} \\－\\―\\‐\\ー・]*$/.test(value) ||
      ErrorTodoMessages.ERWE40012,

    birthdayCheck: value =>
      /^[0-9]{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/.test(value) ||
      value == "" ||
      ErrorTodoMessages.ERWE40044,

    searchTypeCheck: value =>
      value.indexOf("evacuee") !== -1 ||
      value.indexOf("support") !== -1 ||
      ErrorTodoMessages.ERWE40004,

    scopeCheck: value => value.length !== 0 || ErrorTodoMessages.ERWE40004,

    nameKanaDelete: false,
    birthdayDelete: false,
    isPassedValidSearchForm: false,
    dialogOverlay: false
  }),

  computed: {
    evacueeListHeader() {
      return [
        {
          text: "evacuee_id",
          align: " d-none",
          value: "evacuee_id"
        },
        {
          text: "情報区分",
          value: "scope"
        },
        {
          text: "氏名",
          value: "name"
        },
        {
          text: "氏名カナ",
          value: "name_kana"
        },
        {
          text: "性別",
          value: "gender"
        },
        {
          text: "生年月日",
          value: "birthday"
        },
        {
          text: "住所",
          value: "address"
        },
        {
          text: "施設名",
          value: "fa_name"
        },
        {
          text: "最終ステータス",
          value: "final_status"
        },

        {
          text: "安定ヨウ素剤事前配布受取",
          value: "iodine_predistribution"
        },
        {
          text: "安定ヨウ素剤所持",
          value: "iodine_possession"
        },
        {
          text: "安定ヨウ素剤服用",
          value: "iodine_intake"
        },
        {
          text: "妊娠の可能性",
          value: "pregnancy_possibility"
        },
        {
          text: "要配慮の理由",
          value: "required_consideration"
        },
        {
          text: "詳細",
          value: "showDetails"
        }
      ];
    },

    summaryHeader() {
      return [
        {
          text: "一時集合場所",
          value: "temp_shelter_count",
          width: "15%"
        },
        {
          text: "避難退域時検査場所",
          value: "inspection_site_count",
          width: "15%"
        },
        {
          text: "避難所",
          value: "shelter_count",
          width: "15%"
        },
        {
          text: "バス避難",
          value: "bus_evacuation_count",
          width: "15%"
        },
        {
          text: "無し",
          value: "none_count",
          width: "15%"
        },
        {
          text: "合計",
          value: "total_count",
          width: "20%"
        }
      ];
    },

    evacueeActionHistorysHeader() {
      return [
        {
          text: "行動日時",
          value: "action_date"
        },
        {
          text: "避難場所",
          value: "evacuation_place"
        },
        {
          text: "行動履歴",
          value: "action_history"
        }
      ];
    },

    // 発災情報
    disaster() {
      return this.$store.state.disasterInfo.data.results;
    },

    sort() {
      return {
        by: ["action_date"],
        desc: [true]
      };
    }
  },

  created() {
    this.initialize();
  },

  mounted() {
    //this.calculate();
  },

  methods: {
    async initialize() {
      this.overlay = true;
      this.loading = true;
      this.screenTitle = ScreenId.getScreenTitle(this.screenId);
      this.pageTitle(this.screenTitle);
      this.evacueeList = [];
      this.loading = false;
      this.overlay = false;

      //災害名称取得API
      try {
        await this.$store.dispatch(
          "disasterInfo/loadDisasterInfo",
          this.screenId
        );
      } catch (e) {
        this.handleError(e, screen, "aggregation-menu");
      }
      if (hasProperty(this.$disaster, "disaster_no")) {
        this.searchItem.disaster_no = this.$disaster.disaster_no;
      }

      this.disasters = this.$store.state.disasterInfo.data.results;
    },

    // 災害番号フィルタ処理
    disasterNoFilter(value) {
      //this.firstPage();
      // 災害名称と翻訳状況は災害番号でフィルタする
      if (this.disasterName(value) && this.translationStatusFilter(value)) {
        return true;
      } else {
        return false;
      }
    },

    // 災害名称フィルタ処理
    disasterName(value) {
      if (!this.searchItem.disaster_no) {
        return true;
      }
      if (this.searchItem.disaster_no === "all") {
        return true;
      }
      if (this.searchItem.disaster_no === "") {
        return true;
      }

      return value === this.searchItem.disaster_no;
    },

    //検索タイプを選択時、情報区分表示リストを切り替える処理
    radioClick() {
      let radioList = [];
      this.scopeStatus = [];
      if (this.scopeType != this.searchItem.search_type) {
        this.searchItem.scope = "";
      }

      if (this.searchItem.search_type == "evacuee") {
        radioList.push(
          {
            value: "SM",
            text: "スマートフォンアプリ"
          },
          {
            value: "TM",
            text: "仮ＱＲコード"
          },
          {
            value: "SC",
            text: "学校ＱＲコード"
          },
          {
            value: "VU",
            text: "要配慮者施設ＱＲコード"
          }
        );
        this.scopeType = "evacuee";
      } else {
        // disabledになる検索入力欄の入力値をリセット
        this.itemReset();
        radioList.push(
          {
            value: "SU",
            text: "避難行動要支援者名簿"
          },
          {
            value: "SM",
            text: "スマートフォンアプリ"
          },
          {
            value: "TM",
            text: "仮ＱＲコード"
          }
        );
        this.scopeType = "support";
      }
      this.scopeStatus = radioList;
    },

    // 情報区分整合性チェック
    scopeCheckBox(scope, type) {
      let checkBox = [];
      if (type == "evacuee") {
        scope.forEach(function(data) {
          switch (data) {
            case "SM":
              checkBox.push(data);
              break;
            case "TM":
              checkBox.push(data);
              break;
            case "SC":
              checkBox.push(data);
              break;
            case "VU":
              checkBox.push(data);
              break;
            default:
              break;
          }
        });
        return checkBox;
      } else {
        scope.forEach(function(data) {
          switch (data) {
            case "SU":
              checkBox.push(data);
              break;
            case "SM":
              checkBox.push(data);
              break;
            case "TM":
              checkBox.push(data);
              break;
            default:
              break;
          }
        });
        return checkBox;
      }
    },

    // 避難行動要支援者選択時に検索入力項目をリセット
    itemReset() {
      // 検索項目リセット対象
      const resetTarget = [
        "name_kana", //氏名カナ
        "gender", //性別
        "birthday", //生年月日
        "address", //住所
        "fa_name", //施設名
        "last_status", //最終ステータス
        "iodine_predistribution", //安定ヨウ素剤事前配布時受取
        "iodine_possession", //安定ヨウ素剤所持有無
        "iodine_intake", //安定ヨウ素剤服用
        "pregnancy_possibility", //妊娠の可能性
        "required_consideration" //要配慮の理由
      ];
      resetTarget.forEach(target => {
        this.searchItem[target] = "";
      });
    },
    //検索タイプを切り替え時の各検索入力欄の活性制御
    radioCheck() {
      if (this.searchItem.search_type == "support") {
        return true;
      } else {
        return false;
      }
    },

    // 避難情報詳細
    async showDialog(item) {
      this.clearMessage();
      this.overlay = true;
      // 避難者詳細API実行 ユーザIDに紐づく詳細データ取得
      await evacueeInfoRepository
        .detail(this.screenId, item.user_id, this.searchItem.disaster_no)
        .then(response => {
          this.detailItem = response.data.results[0];
        })
        .catch(e => {
          this.handleCreateError(e);
        });
      // 詳細データのフォーマット
      this.createDetailTableDataList(this.detailItem);
      this.convEvacuation_history(this.detailItem);
      // フォーマット後の詳細データを詳細ダイアログ表示欄にセット
      this.evacueeDetails = this.detailItem;
      // 詳細ダイアログの表示
      this.detailsDialog = true;
      this.overlay = false;
    },
    // 行動履歴に表示する日付のフォーマット
    convEvacuation_history(data) {
      let actionDate = "";
      if (data.evacuation_history.length != 0) {
        let dataList = data.evacuation_history;
        for (var i = 0; i < dataList.length; i++) {
          if (dataList[i].action_date == "") {
            actionDate = "";
          } else {
            actionDate = this.formatDatetime(dataList[i].action_date);
            dataList[i].action_date = actionDate;
          }
        }
      }
    },

    // TIMESATMPを変換
    formatDatetime(datetime) {
      if (!datetime) {
        return "";
      }
      const formattedDatetime = this.$moment(datetime, "YYYYMMDDHHmmss");
      return formattedDatetime.format("YYYY/MM/DD HH:mm");
    },

    /* 検索詳細テーブルデータフォーマット */
    createDetailTableDataList(data) {
      // 性別
      switch (data.gender) {
        case "1":
          data.gender = "男";
          break;
        case "2":
          data.gender = "女";
          break;
        case "3":
          data.gender = "どちらでもない";
          break;
        default:
          data.gender = "";
          break;
      }
      // 生年月日(形式：YYYYMMDD)
      data.birthday =
        data.birthday == ""
          ? ""
          : this.$moment(data.birthday, "YYYYMMDD").format("YYYY/MM/DD");
      // 最終ステータス
      switch (data.final_status) {
        case "1":
          data.final_status = "避難所";
          break;
        case "2":
          data.final_status = "一時集合場所";
          break;
        case "4":
          data.final_status = "避難退域時検査場所";
          break;
        case "9":
          data.final_status = "バス避難";
          break;
        default:
          data.final_status = "";
          break;
      }
      const isExistText = {
        "0": "無",
        "1": "有"
      };
      // 安定ヨウ素剤事前配布受取
      data.iodine_predistribution =
        data.iodine_predistribution == ""
          ? ""
          : isExistText[data.iodine_predistribution];
      // 安定ヨウ素剤所持
      data.iodine_possession =
        data.iodine_possession == "" ? "" : isExistText[data.iodine_possession];
      // 安定ヨウ素剤服用
      data.iodine_intake =
        data.iodine_intake == "" ? "" : isExistText[data.iodine_intake];
      // 妊娠有無
      data.pregnancy_possibility =
        data.pregnancy_possibility == ""
          ? ""
          : isExistText[data.pregnancy_possibility];
    },

    // 検索処理（リクエスト生成とAPIリクエスト）
    async calculate() {
      this.clearMessage();
      // 避難検索情報
      let payload = {};
      // 検索対象radio
      if (this.searchItem.search_type) {
        payload.search_type = this.searchItem.search_type;
      }
      // 情報区分
      if (this.searchItem.scope) {
        payload.scope = this.scopeCheckBox(
          this.searchItem.scope,
          this.searchItem.search_type
        );
      }
      // 災害番号
      if (this.searchItem.disaster_no) {
        payload.disaster_no = this.searchItem.disaster_no;
      }
      // 氏名
      if (this.searchItem.name) {
        payload.name = this.searchItem.name;
      }
      // 氏名カナ
      if (this.searchItem.name_kana) {
        payload.name_kana = this.searchItem.name_kana;
      }
      // 性別
      if (this.searchItem.gender) {
        payload.gender = this.searchItem.gender;
      }
      // 生年月日
      if (this.searchItem.birthday) {
        payload.birthday = this.convBirthday(this.searchItem.birthday);
      }
      // 住所
      if (this.searchItem.address) {
        payload.address = this.searchItem.address;
      }
      // 施設名
      if (this.searchItem.fa_name) {
        payload.fa_name = this.searchItem.fa_name;
      }
      // 原子力防災施設区分
      if (this.searchItem.last_status) {
        payload.last_status = this.searchItem.last_status;
      }
      // 安定ヨウ素剤事前配布受取
      if (this.searchItem.iodine_predistribution) {
        payload.iodine_predistribution = this.searchItem.iodine_predistribution;
      }
      // 安定ヨウ素剤所持
      if (this.searchItem.iodine_possession) {
        payload.iodine_possession = this.searchItem.iodine_possession;
      }
      // 安定ヨウ素剤服用
      if (this.searchItem.iodine_intake) {
        payload.iodine_intake = this.searchItem.iodine_intake;
      }
      // 妊娠の可能性
      if (this.searchItem.pregnancy_possibility) {
        payload.pregnancy_possibility = this.searchItem.pregnancy_possibility;
      }
      // 要配慮の理由
      if (this.searchItem.required_consideration) {
        payload.required_consideration = this.searchItem.required_consideration;
      }

      // 避難者検索API実行
      await evacueeInfoRepository
        .list(this.screenId, payload)
        .then(response => {
          this.pushItem = response.data.results;
        })
        .catch(e => {
          this.errFlag = true;
          this.handleCreateError(e);
        });
      this.createTableDataList(this.pushItem);
      this.evacueeList = this.pushItem;

      //this.$nextTick(() => {
      if (this.$refs.summary) {
        this.summaryFiled = [];
        const summary = this.evacueeList;

        const totalCount = this.evacueeList.length;
        let shelterCount = 0;
        let tempShelterCount = 0;
        let inspectionSiteCount = 0;
        let busEvacuationCount = 0;
        summary.forEach(item => {
          const facility = item.final_status;
          if (typeof facility !== "undefined") {
            switch (facility) {
              case "避難所":
                shelterCount++;
                break;
              case "一時集合場所":
                tempShelterCount++;
                break;
              case "避難退域時検査場所":
                inspectionSiteCount++;
                break;
              case "バス避難":
                busEvacuationCount++;
                break;
              default:
                break;
            }
          }
        });
        const calc_count =
          totalCount -
          shelterCount -
          tempShelterCount -
          inspectionSiteCount -
          busEvacuationCount;
        const sumItems = {
          shelter_count: shelterCount,
          temp_shelter_count: tempShelterCount,
          inspection_site_count: inspectionSiteCount,
          bus_evacuation_count: busEvacuationCount,
          none_count: calc_count,
          total_count: totalCount
        };
        this.summaryFiled.push(sumItems);
      }
      //});
    },

    /**
     * ページを1ページ目に戻す
     */
    resetPage() {
      //this.currentPage = 1;
      this.$refs.summary.resetPage();
    },

    /* 検索テーブルデータ作成 */
    createTableDataList(data) {
      data.forEach((item, i) => {
        // 情報区分
        switch (item.scope) {
          case "SM":
            data[i].scope = "ス";
            break;
          case "TM":
            data[i].scope = "仮";
            break;
          case "SC":
            data[i].scope = "学校";
            break;
          case "VU":
            data[i].scope = "配慮";
            break;
          case "SU":
            data[i].scope = "支援";
            break;
          default:
            data[i].scope = "";
            break;
        }
        // 性別
        switch (item.gender) {
          case "1":
            data[i].gender = "男";
            break;
          case "2":
            data[i].gender = "女";
            break;
          case "3":
            data[i].gender = "どちらでもない";
            break;
          default:
            data[i].gender = "";
            break;
        }
        // 生年月日(形式：YYYYMMDD)
        data[i].birthday =
          item.birthday == ""
            ? ""
            : this.$moment(item.birthday, "YYYYMMDD").format("YYYY/MM/DD");
        // 最終ステータス
        switch (item.final_status) {
          case "1":
            data[i].final_status = "避難所";
            break;
          case "2":
            data[i].final_status = "一時集合場所";
            break;
          case "4":
            data[i].final_status = "避難退域時検査場所";
            break;
          case "9":
            data[i].final_status = "バス避難";
            break;
          default:
            data[i].final_status = "";
            break;
        }
        const isExistText = {
          "0": "無",
          "1": "有"
        };
        // 安定ヨウ素剤事前配布受取
        data[i].iodine_predistribution =
          item.iodine_predistribution == ""
            ? ""
            : isExistText[item.iodine_predistribution];
        // 安定ヨウ素剤所持
        data[i].iodine_possession =
          item.iodine_possession == ""
            ? ""
            : isExistText[item.iodine_possession];
        // 安定ヨウ素剤服用
        data[i].iodine_intake =
          item.iodine_intake == "" ? "" : isExistText[item.iodine_intake];
        // 妊娠有無
        data[i].pregnancy_possibility =
          item.pregnancy_possibility == ""
            ? ""
            : isExistText[item.pregnancy_possibility];
      });
    },
    // 氏名カナ・生年月日のクリア処理
    clearText(value) {
      switch (value) {
        case "name_kana":
          this.searchItem.name_kana = "";
          this.nameKanaDelete = false;
          break;
        case "birthday":
          this.searchItem.birthday = "";
          this.birthdayDelete = false;
          break;
        default:
          break;
      }
    },
    // 氏名カナ・生年月日のクリアアイコン表示制御
    showCancelIcon(value) {
      switch (value) {
        case "name_kana":
          if (this.searchItem.name_kana != "") {
            this.nameKanaDelete = true;
          } else {
            this.nameKanaDelete = false;
          }
          break;
        case "birthday":
          if (this.searchItem.birthday != "") {
            this.birthdayDelete = true;
          } else {
            this.birthdayDelete = false;
          }
          break;
        default:
          break;
      }
    },

    //生年月日yyyy/mm/dd ⇒ yyyymmdd変換
    convBirthday(value) {
      return value.replace(/\//g, "");
    },

    showSearchDialog() {
      if (this.$refs.form.validate() === false) {
        return;
      }
      this.searchDialog = true;
    },

    async search() {
      this.dialogOverlay = true;
      this.evacuee_table = true;
      this.errFlag = false;
      await this.calculate();
      this.resetPage();
      this.goto();
      this.searchDialog = false;
      this.dialogOverlay = false;
    },

    // 最下部へスクロール
    goto() {
      let bodyHeight;
      if (this.errFlag) {
        bodyHeight = 0;
      } else {
        bodyHeight = document.body.clientHeight;
      }
      this.$vuetify.goTo(bodyHeight);
    },

    /**
     * データテーブル表示用（生年月日）
     */
    formatBirthDay(date) {
      const formattedDate = this.$moment(date);
      if (formattedDate.isValid()) {
        return formattedDate.format("YYYY年MM月DD日");
      }
      return "";
    }
  },

  filters: {
    format: function(value) {
      return `${value}人`;
    }
  },

  watch: {
    $route: "initialize"
  }
};

const STATUS_LIST = Object.freeze([
  {
    fa_id: "2",
    fa_type: "一時集合場所"
  },
  {
    fa_id: "4",
    fa_type: "避難退域時検査場所"
  },
  {
    fa_id: "1",
    fa_type: "避難所"
  },
  {
    fa_id: "9",
    fa_type: "バス避難"
  }
]);

const WHICH_CHOOSE = Object.freeze([
  [
    {
      status_id: "0",
      status_text: "無"
    },
    {
      status_id: "1",
      status_text: "有"
    }
  ],
  [
    {
      status_id: "1",
      status_text: "男"
    },
    {
      status_id: "2",
      status_text: "女"
    },
    {
      status_id: "3",
      status_text: "どちらでもない"
    }
  ]
]);
</script>
